import { render, staticRenderFns } from "./SettingsDiscountPresets.vue?vue&type=template&id=14fb20ee&scoped=true"
import script from "./SettingsDiscountPresets.vue?vue&type=script&lang=js"
export * from "./SettingsDiscountPresets.vue?vue&type=script&lang=js"
import style0 from "./SettingsDiscountPresets.vue?vue&type=style&index=0&id=14fb20ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fb20ee",
  null
  
)

export default component.exports